export class GeoJson {
    constructor() {
        this.type = "Feature";
        this.properties = {};
    }

    type: "Feature";
    properties: { [key: string]: any };
    geometry?: Geometry;
}

export class Geometry {
    constructor(){
        this.type = "Point";
        this.coordinates = [];
    }

    type: "Point" | "Polygon";
    coordinates: number[] | number[][][]
}